import Pikaday from 'pikaday';

function createDatePicker() {
    Array.from(document.getElementsByClassName('pd-date')).forEach((k) => {
        // eslint-disable-next-line
        new Pikaday({
            field: k,
            format: 'MM/DD/YYYY',
        });
    });
}

function mask(target) {
    // console.log('mask: ', target)

    let { value: v } = target;
    // console.log('v: ', v)
    // if (v.match(/^\d{2}$/) !== null) {
    //   target.value = `${v}/`
    // } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
    //   target.value = `${v}/`
    // }

    const date = v;
    if (date.match(/^\d{4}$/) !== null) {
        v = date + '/';
    } else if (date.match(/^\d{4}\/\d{2}$/) !== null) {
        v = date + '/';
    }
}

function init() {
    createDatePicker();

    Array.from(document.getElementsByClassName('pd-date')).forEach((k) => {
        k.addEventListener('keyup', (e) => mask(e.target));

        k.removeAttribute('readonly');
    });
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/date-picker.js